import prototypeScroll from './_scroll.js'
import prototypeRouter from './_router.js'
import prototypeDateAndTime from './_dateAndTime.js'
import prototypeCheckAccess from './_checkAccess.js'
import prototypeNavigationGuardian from './_navigationGuardian.js'
import prototypeFile from './_file.js'
import prototypeCommon from './_common.js'
import prototypeColors from './_colors'

export default {
  ...prototypeScroll,
  ...prototypeRouter,
  ...prototypeDateAndTime,
  ...prototypeCheckAccess,
  ...prototypeNavigationGuardian,
  ...prototypeFile,
  ...prototypeCommon,
  ...prototypeColors,
}
